import { AxiosError } from "axios";
import React from "react";
import { ApolloError } from "@apollo/client";
import { TUser } from "../../generated/gql/graphql";
import { GraphQLError } from "graphql";

export const EmbeddedAppContext = React.createContext({
  isEmbedded: false,
  isChromeExtension: false,
  useLocalhost: false,
  tabId: undefined as (number | undefined),
  parentTabId: undefined as (number | undefined),
});
